module.exports = __webpack_public_path__ + "static/contact-39ee71d40d1497cc17156617d898ef96.svg";